import React from 'react';
import Dropzone from 'react-dropzone';
import {
  ContentWrapper,
  UploaderHeading,
  UploaderLabel,
  UploaderLink,
} from './styles';
import {
  ACCEPTED_FILE_TYPES_AUDIO_USERS,
  ACCEPTED_FILE_TYPES_VIDEO_USERS,
  DROPZONE_COPY_AUDIO_USERS,
  DROPZONE_COPY_VIDEO_USERS,
} from '../constants';

type IdleStateProps = {
  onUploadFile: (uploadedFile: File) => void;
  onUploadUnsupportedFile: () => void;
  onDragEnter: () => void;
  onDragLeave: () => void;
  isVideoPodcaster: boolean;
};

export const IdleState = ({
  onUploadFile,
  onUploadUnsupportedFile,
  onDragEnter,
  onDragLeave,
  isVideoPodcaster,
}: IdleStateProps) => {
  const openFilePicker = (e: React.FormEvent, open: () => void) => {
    e.preventDefault();
    open();
  };

  const handleOnDrop = (acceptedFiles: File[]) => {
    onDragLeave();
    onUploadFile(acceptedFiles[0]);
  };

  return (
    <Dropzone
      onDropAccepted={handleOnDrop}
      onDropRejected={onUploadUnsupportedFile}
      accept={
        isVideoPodcaster
          ? ACCEPTED_FILE_TYPES_VIDEO_USERS
          : ACCEPTED_FILE_TYPES_AUDIO_USERS
      }
      noClick
      noKeyboard
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      maxFiles={1}
    >
      {({ getRootProps, getInputProps, open }) => {
        return (
          <ContentWrapper {...getRootProps()} data-testid="dropzone">
            <input {...getInputProps()} />
            <div>
              <UploaderHeading>
                Drag & drop files here to upload, or{' '}
                <UploaderLink onClick={e => openFilePicker(e, open)}>
                  browse
                </UploaderLink>
                .
              </UploaderHeading>
              <UploaderLabel>
                {isVideoPodcaster
                  ? DROPZONE_COPY_VIDEO_USERS
                  : DROPZONE_COPY_AUDIO_USERS}
              </UploaderLabel>
            </div>
          </ContentWrapper>
        );
      }}
    </Dropzone>
  );
};
